import React, { Component } from 'react';
import './CSS/micomp.css';
import './App.css';
import './CSS/auttcontrol.css';
import 'font-awesome/css/font-awesome.min.css';
import 'react-alice-carousel/lib/alice-carousel.css';
import Authcontrol from './components/Auth/Authcontrol'
import {
  message
} from "antd";
message.config({
  top: 250,
  duration: 10,
  maxCount: 3,

});
class App extends Component {
  render() {
    return (
      <Authcontrol />
    );
  }
}
export default App;
